import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import "primeicons/primeicons.css";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Textarea from "@mui/joy/Textarea";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useBlogCalls from "../../service/useBlogCalls";

const status = [
  { name: "Draft", value: false },
  { name: "Published", value: true },
];

const BlogModal = ({ open, handleClose, item }) => {
  // console.log("🚀 ~ BlogModal ~ item:", item);
  const { getData, putBlog } = useBlogCalls();
  const { categories } = useSelector((state) => state.blog);
  const navigate = useNavigate();
  // console.log(categories);
  const { categoryId, title, image, isPublish, content , _id:id} = item;

  const initialValue = {
    categoryId: categoryId,
    title: title,
    content: content,
    image: image,
    isPublish: isPublish,
  };
  const [blog, setBlog] = useState(initialValue);
  const handleChange = (e) => {
    setBlog({ ...blog, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(blog);
    putBlog(blog,id);
    navigate("/");
  };
  useEffect(() => {
    getData("categories");
  }, []);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        //   className="newBlog"
        style={{ marginTop: "5rem", textAlign: "center", padding: "1rem" }}
      >
        <Box
          sx={{
            mx: "auto",
            display: "flex",
            marginTop: "2rem",
            flexDirection: "column",
            gap: 2,
          }}
          component="form"
          onSubmit={handleSubmit}
          style={{
            width: "50%",
            border: "2px  solid black",
            borderRadius: "10px",
            padding: "1rem",
            backgroundColor: "rgba(255,255,255,0.7)",
            boxShadow: "10px 10px 25px white",
            color: "#1d3557",
          }}
        >
          <Typography
            style={{
              fontSize: "2rem",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            New Blog
          </Typography>
          <TextField
            label="Title"
            name="title"
            id="title"
            type="text"
            variant="outlined"
            value={blog?.title}
            onChange={handleChange}
            required
          />
          <TextField
            label="Image URL"
            name="image"
            id="image"
            type="url"
            variant="outlined"
            value={blog?.image}
            onChange={handleChange}
            required
          />
          <FormControl>
            <InputLabel variant="outlined" id="category">
              Category
            </InputLabel>
            <Select
              labelId="categoryId"
              label="Category"
              id="categoryId"
              name="categoryId"
              value={blog?.categoryId}
              onChange={handleChange}
              required
            >
              <MenuItem disabled>Select the Category</MenuItem>
              <hr />
              {categories.map((item) => {
                return (
                  <MenuItem key={item?._id} value={item?._id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel variant="outlined" id="status">
              Status
            </InputLabel>
            <Select
              labelId="status"
              label="Status"
              id="isPublish"
              name="isPublish"
              value={blog.isPublish}
              onChange={handleChange}
              required
            >
              <MenuItem disabled>Add New Product</MenuItem>
              <hr />
              {status.map((item, i) => (
                <MenuItem key={i} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Textarea
            placeholder="Content"
            label="Content"
            required
            name="content"
            id="content"
            variant="outlined"
            value={blog.content}
            minRows={2}
            maxRows={4}
            onChange={handleChange}
          />

          <Button
            className="newBlog-btn"
            type="submit"
            variant="contained"
            size="large"
          >
        Update Blog
          </Button>
        </Box>
      </div>
    </Modal>
  );
};

export default BlogModal;
